import pDefer, { DeferredPromise } from "p-defer"
import { apiClient } from "infra/api-client"
import { BASE_URL } from "global"
import { LllNode } from "modules/lll/lll-nodes"


class LllLookupService {

  private static cache_expiry = 10 * 60 * 1000;

  private defer!: DeferredPromise<LllNode>
  private nodes: Record<string, LllNode> = {};
  private baseUrl!: string;

  constructor() {
    // @ts-ignore
  }

  private flatten(rootNode: LllNode) {
    const result: Record<string, LllNode> = {};

    function addNode(node: LllNode) {
      result[node.fqn] = node;
      node.getChildren()?.forEach(child => {
        addNode(child);
      })
    }
    addNode(rootNode);
    this.nodes = result;
  }

  get flatNodes() {
    return this.nodes;
  }

  getBaseUrl(){
    return this.baseUrl;
  }

  private async fetchActivityTree() {

    const response = await apiClient.get<{
      baseUrl: string;
      activityTree: Record<string, any>;
    }>(BASE_URL + "lll/getActivityTree", {});

    try {
      this.baseUrl = response.data.baseUrl
      const root = LllNode.createNode(response.data.activityTree)

      if(this.defer) {
        this.defer.resolve(root)
      }
      this.flatten(root)
      setTimeout(() => {
        this.defer = null!
      }, LllLookupService.cache_expiry)
    } catch (error) {
      if (this.defer) {
        this.defer.reject(error);
        this.defer = null!;
      }
    }
  }

  getActivityTree(): Promise<LllNode> {
    if (!this.defer) {
      this.defer = pDefer();
      this.fetchActivityTree();
    }

    return this.defer.promise
  }

  findNodeByFqn(fqn: string){
    return this.flatNodes[fqn];
  }

}

export const lllLookupService = new LllLookupService();